'use client';

import { SignIn } from '@clerk/nextjs';
import { datadogLogs } from '@datadog/browser-logs';

import { decryptData } from '~/utils/encryption';

export default function Page() {
  return (
    <main className="grid h-screen w-screen place-items-center pt-4">
      <SignIn
        appearance={{
          elements: {
            logoBox: 'flex items-center w-full h-auto',
            footer: 'hidden',
          },
        }}
        fallbackRedirectUrl="/appointments"
        forceRedirectUrl={
          typeof window !== 'undefined'
            ? (sessionStorage.getItem('redirectAfterSignIn') ?? '/appointments')
            : '/appointments'
        }
        initialValues={{
          emailAddress: (() => {
            if (typeof window === 'undefined') return undefined;
            const savedEmail = localStorage.getItem('savedEmail');
            try {
              if (!savedEmail) {
                return undefined;
              }
              const decryptedEmail = decryptData(savedEmail);
              return decryptedEmail || undefined;
            } catch (error) {
              const ctx = {
                className: 'SignIn',
                functionName: 'decryptEmail',
              };

              if (error instanceof Error) {
                datadogLogs.logger.error('encryption error', ctx, error);
              } else {
                datadogLogs.logger.error(
                  `Unexpected error type - ${String(error)}`,
                );
              }
              return undefined;
            }
          })(),
        }}
      />
    </main>
  );
}
